<template>
    <div class="sync-flow-editor">
        <!-- Меню -->
        <div v-if="!isViewMode" class="sfe-menu">

            <div class="form-box-title">
                <span>Процессы</span>
            </div>

            <v-text-field
                append-icon="fas fa-search"
                label="Поиск"
                hide-details
                solo
                flat
                clearable
                class="sfe-menu-search"
            ></v-text-field>

            <v-list-group
                v-for="(item, i) in processItemsMenuTree"
                :key="i"
                :value="processItemsMenuActiveGroup === i"
                @input="onGroupMenuInput(i, $event)"
                color="#125780"
            >
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t(item.name) }}</v-list-item-title>
                    </v-list-item-content>
                </template>

                <draggable
                    :list="item.items"
                    item-key="id"
                    :group="{ name: item.group, pull: 'clone', put: false }"
                    :sort="false"
                >
                    <template v-for="child in item.items">
                        <v-list-item
                            :key="child.id"
                            draggable="true"
                            @dragstart="onDragStart(child, $event)"
                            @dragend="onDragEnd"
                            v-tooltip.top-center="child.displayName"
                        >
                            <v-list-item-icon>
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t(child.displayName) }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </draggable>

            </v-list-group>

        </div>

        <div class="sfe-content" @dragover.prevent @drop="onDiagramDrop">

            <div v-if="!isViewMode" class="sfe-toolbar">
                <v-btn fab x-small @click="undo" v-tooltip.top-center="'Назад'">
                    <v-icon>fas fa-undo-alt</v-icon>
                </v-btn>
                <v-btn fab x-small @click="redo" v-tooltip.top-center="'Вперед'">
                    <v-icon>fas fa-redo-alt</v-icon>
                </v-btn>
                <v-btn fab x-small @click="deleteItem" :disabled="!hasSelection" v-tooltip.top-center="'Удалить'">
                    <v-icon>fas fa-trash-alt</v-icon>
                </v-btn>
                <v-btn fab x-small @click="onValidateScheme()" v-tooltip.top-center="'Проверить'">
                    <v-icon>fas fa-project-diagram</v-icon>
                </v-btn>
                <!--
                <v-btn fab x-small @click="save">
                    <v-icon>fas fa-save</v-icon>
                </v-btn>
                <v-btn fab x-small @click="load">
                    <v-icon>fas fa-chevron-down</v-icon>
                </v-btn>-->
				<!--
				<v-btn fab x-small @click="setConnectorMode">
					<v-icon>fas fa-level-down-alt</v-icon>
				</v-btn>
				-->
            </div>

            <ejs-diagram
                id="diagram"
                ref="diagram"
                :width="width"
                :height="height"
                :nodes="nodes"
                :connectors="connectors"
                :tool="tool"
                :collectionChange="onCollectionChange"
                :selectionChange="onSelectionChange"
                :constraints="constraints"
                :click="onPortClick"
            ></ejs-diagram>

            <v-navigation-drawer
                v-model="drawerPropSettings"
                v-if="selectionNodeData?.length > 0 || (validator !== null && lastErrorMessage !== null && this.lastErrorNodeId == this.selectionNodeId)"
                absolute
                right
                max-width="400"
                width="400"
                class="drawerPropSettings wrapperForm"
                hide-overlay
            >
                <div class="sfe-menu sfe-menu-prop">
                    <div class="form-box-title">
                        <span>Свойства</span>
                    </div>
                    <v-form
                        class="wrapperForm"
                        ref="formPropertiesRef"
                        lazy-validation
                    >
                        <v-alert
                            v-if="validator !== null && lastErrorMessage !== null && this.lastErrorNodeId == this.selectionNodeId"
                            type="error"
                            border="left"
                            text
                            prominent
                            class="mt-2 ml-4 mr-4 mb-4"
                            :color="validateErrorColor"
                            dense
                        >
                            <ul>
                                <li>{{ lastErrorMessage }}</li>
                            </ul>
                        </v-alert>
                        <v-list-group
                            v-for="(item, i) in this.selectionNodeData"
                            :key="i"
                            :value="propertyItemsMenuActiveGroup === i"
                            @input="onPropertyGroupMenuInput(i, $event)"
                            color="#125780"
                        >
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title>{{ $t(item.name) }}</v-list-item-title>
                                </v-list-item-content>
                            </template>

                            <v-card flat>
                                <v-card-text>
                                    <template v-for="child in item.items">
                                        <v-row 
                                            :key="child.id" 
                                            v-if="isPropertyVisible(child)"
                                            no-gutters
                                        >
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t(child.displayName) }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                
                                                <!-- Boolean -->
                                                <v-switch
                                                    v-if="child.webEditorAttribute.Type == 'Boolean'"
                                                    inset
                                                    hide-details
                                                    class="cust-switch"
                                                    :input-value="currentPropValues[child.name]"
                                                    @change="onPropChange($event, child.name, child.webEditorAttribute.Type)"
                                                    :disabled="isViewMode"
                                                />

                                                <!-- Enum -->
                                                <v-select
                                                    v-if="child.webEditorAttribute.Type == 'Enum'"
                                                    :items="child.enumValues"
                                                    item-text="Description"
                                                    item-value="Value"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                    :value="currentPropValues[child.name]"
                                                    @change="onPropChange($event, child.name, child.webEditorAttribute.Type)"
                                                    :disabled="isViewMode"
                                                    :rules="child.webEditorAttribute.Params?.required ? selectNoDefaulRule : []"
                                                >
                                                </v-select>

                                                <!-- String -->
                                                <v-text-field
                                                    v-if="child.webEditorAttribute.Type == 'String'"
                                                    hide-details
                                                    outlined
                                                    dense
                                                    required
                                                    :value="currentPropValues[child.name]"
                                                    @input="onPropChange($event, child.name, child.webEditorAttribute.Type)"
                                                    :disabled="isViewMode"
                                                    :rules="child.webEditorAttribute.Params?.required ? requiredRule : []"
                                                ></v-text-field>

                                                <!-- TimeSpan -->
                                                <v-text-field
                                                    v-if="child.webEditorAttribute.Type == 'TimeSpan'"
                                                    v-mask="'##:##'"
                                                    placeholder="00:00"
                                                    clearable
                                                    hide-details
                                                    outlined
                                                    dense
                                                    required
                                                    :value="currentPropValues[child.name]"
                                                    @input="onPropChange($event, child.name, child.webEditorAttribute.Type)"
                                                    :disabled="isViewMode"
                                                    :rules="child.webEditorAttribute.Params?.required ? timehhmmRule : []"
                                                ></v-text-field>

                                                <!-- Workplace -->
                                                <template v-if="child.webEditorAttribute.Type == 'Workplace' && !isGlobal">
                                                    <div class="icon-click-row-group icrg-align-center">
                                                        <div
                                                            v-if="!isViewMode" 
                                                            @click="onWorkplaceSelect(child.webEditorAttribute.Params, child.name)"
                                                        >
                                                            <v-icon v-tooltip.left-center="'Выбрать'" small>
                                                                fas fa-edit
                                                            </v-icon>
                                                        </div>
                                                        <div v-if="currentPropValues[child.name]" class="onlyReadData">
                                                            <v-workplace-chip
                                                                v-for="item in currentPropValues[child.name]"
                                                                :key="item.employeeId"
                                                                :id="item.workplaceId"
                                                                :name="item.name"
                                                                :canDelete="true"
                                                                :canNavigate="false"
                                                            />
                                                            <!--:delFunc="onRemoveWorkplace"-->
                                                        </div>
                                                        <div 
                                                            v-else 
                                                            :class="isViewMode ? 'onlyReadData' : 'chipAreaNoData d-flex align-center pl-1'"
                                                        >
                                                            <template v-if="isViewMode">{{ $t("Не_указано") }}</template>
                                                        </div>
                                                    </div>
                                                </template>

                                            </v-col>
                                        </v-row>
                                    </template>    
                                </v-card-text>
                            </v-card>
                        </v-list-group>
                    </v-form>
                </div>
            </v-navigation-drawer>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { registerLicense } from "@syncfusion/ej2-base";
import { DiagramPlugin, DiagramTools, BpmnDiagrams, Tooltip as DiagramTooltip } from "@syncfusion/ej2-vue-diagrams";
// Нужные классы/модули из ядра EJ2
import { Diagram, UndoRedo, DiagramConstraints, PortVisibility, PortConstraints, NodeConstraints, ConnectorConstraints } from "@syncfusion/ej2-diagrams";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-diagrams/styles/material.css";
import "@syncfusion/ej2-navigations/styles/material.css";
import "@syncfusion/ej2-popups/styles/material.css";
import "@syncfusion/ej2-splitbuttons/styles/material.css";

// undo/redo
Diagram.Inject(UndoRedo);
registerLicense("Ngo9BigBOggjGyl/Vkd+XU9FcVRDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3tSdkVhWXdbeXVST2ZUUk91Xg==");
Vue.use(DiagramPlugin);

import draggable from "vuedraggable";
import _ from "lodash";
import { mapGetters } from 'vuex';

const nodeIdPrefix = "Node_";
const findSmallest = function (nums) {
    let seen = new Array(nums.length + 1).fill(false);

    for (let num of nums) {
        seen[num] = true;
    }

    let index = seen.findIndex((e) => !e);
    return index < 0 ? 0 : index;
};
const STATIC_CONNECTOR_CONSTRAINTS = 
    ConnectorConstraints.Default
    ^ ConnectorConstraints.ReadOnly      // Запрет редактирования описания коннекции
    ^ ConnectorConstraints.Drag          // Запрет перемещения всего коннектора (после выделения)
    ^ ConnectorConstraints.DragSourceEnd // Запрет перемещения стартовой точки
    ^ ConnectorConstraints.DragTargetEnd;// Запрет перемещения целевой точки

export default {
	name: "FlowEditor",
	props: {
		isViewMode: {
            type: Boolean,
            default: true
        },
        activities: {
            type: Array,
            default: () => []
        },
        enterprise: {
            type: String,
            default: '00000000-0000-0000-0000-000000000000'
        },
        validator: {
            type: Function,
            default: null
        }
	},
    provide: {
        // Инжектируем BPMN-провайдер в компонент
        diagram: [BpmnDiagrams, DiagramTooltip],
    },
    components: {
        draggable,
    },
    computed: {
        ...mapGetters({ requiredRule: 'getRequiredRule', selectNoDefaulRule: 'getSelectNoDefaulRule', timehhmmRule: 'getTimehhmmRule' }),
        currentPropValues() {
            let schemeDataItemId = Number(this.selectionNodeId.replace(nodeIdPrefix, ""));
            return this.schemeData.find((x) => x.Id == schemeDataItemId);
        },
        isGlobal(){
            return this.enterprise === '00000000-0000-0000-0000-000000000000';
        }
    },
    data() {
        return {
            width: "100%",
            height: "100%",
            tool: DiagramTools.SingleSelect | DiagramTools.ZoomPan,
            // включаем constraint для undo/redo
            constraints: DiagramConstraints.Default | DiagramConstraints.UndoRedo,
            nodes: [],
            connectors: [],
            processItemsMenuActiveGroup: 1,
            processItemsMenuTree: [],
            draggedItem: null,
            hasSelection: false,
            // правая панель
            drawerPropSettings: false,
            selectionNodeId: null,
            selectionNodeData: null,
            defaultValidNodeStrokeColor: null,
            lastErrorNodeId: null,  
            lastErrorMessage: null,
            validateErrorColor: "#F44336",
            propertyItemsMenuActiveGroup: 0,
            propertyItemsMenuTree: [],
            // порты
            firstPort: null,
            schemeData: [],
        };
    },
    methods: {
        onGroupMenuInput(i, isOpen) {
            this.processItemsMenuActiveGroup = isOpen ? i : null;
        },
        onPropertyGroupMenuInput(i, isOpen) {
            this.propertyItemsMenuActiveGroup = isOpen ? i : null;
        },
        getDiagram() {
            return this.$refs.diagram.ej2Instances;
        },
        setConnectorMode() {
            const diagram = this.getDiagram();
            diagram.tool = DiagramTools.ContinuousDraw;
            diagram.drawingObject = {
                type: "Orthogonal",
                annotations: [
                    {
                        style: {
                            color: "black",
                            fill: "#fff",
                            strokeColor: "#fff",
                        },
                    },
                ],
            }; // тип связи
            diagram.dataBind();
        },
        undo() {
            this.getDiagram().undo();
        },
        redo() {
            this.getDiagram().redo();
        },
        deleteItem() {
            this.getDiagram().cut();
            this.hasSelection = false;
        },
        onCollectionChange(args) {
            const diagram = this.getDiagram();
            // Проверяем, что добавлен новый элемент, и это коннектор
            if (args.state === "Changed" && args.type === "Addition" && args.element && args.element.id && args.element.id.includes("connector")) {
                const connector = args.element;
                const sourcePortId = connector.sourcePortID;
                let shouldRemove = false;

                if (connector.sourceID && connector.targetID) {
                    // ПРИНУДИТЕЛЬНАЯ БЛОКИРОВКА ИЗМЕНЕНИЙ
                    connector.constraints = STATIC_CONNECTOR_CONSTRAINTS;
                }
                // --- ЛОГИКА ПРОВЕРКИ ОГРАНИЧЕНИЙ ---
                // 1. Проверяем, что коннектор подключен к ИСТОЧНИКУ и ЦЕЛИ (нода/порт)
                if (!connector.sourceID || !connector.targetID) {
                    shouldRemove = true;
                    console.log("Коннектор не подключен к узлам.");
                }
                // 2. Проверка: Запрет соединения внутри одной ноды
                else if (connector.sourceID === connector.targetID) {
                    shouldRemove = true;
                    console.log("Соединение в пределах одной ноды запрещено.");
                }
                // 3. Проверка и Автоматическая Привязка к Порту
                else {
                    const sourceNode = diagram.getObject(connector.sourceID);
                    const targetNode = diagram.getObject(connector.targetID);
                    const firstPortObj = sourceNode?.ports?.find((p) => p.id === sourcePortId);

                    let annotationContent = "";

                    if (firstPortObj && firstPortObj.tooltip && firstPortObj.tooltip.content) {
                        // Используем контент тултипа ИСХОДЯЩЕГО порта
                        annotationContent = firstPortObj.tooltip.content;
                    }

                    // Если коннектор не привязан к targetPortID (пристыкован к ноде)
                    if (!connector.targetPortID) {
                        // Находим первый входящий порт (InConnect) на целевой ноде
                        const targetPortObj = targetNode?.ports?.find((p) => p.constraints & PortConstraints.InConnect);

                        if (targetPortObj) {
                            // *** АВТОМАТИЧЕСКАЯ ПРИВЯЗКА ***
                            // Назначаем targetPortID коннектору и обновляем его
                            connector.targetPortID = targetPortObj.id;
                            connector.targetPoint = undefined; // Удаляем временную точку
                            console.log(`Коннектор автоматически привязан к порту: ${targetPortObj.id}`);
                            //console.log('sourcePortId', sourcePortId);
                            //console.log('connector.targetID', connector.targetID);
                            //console.log('connector.sourceID', connector.sourceID);
                        } 
						else {
                            shouldRemove = true;
                            console.log("На целевой ноде нет доступного входящего порта (InConnect).");
                        }
                    }

                    if (!shouldRemove && annotationContent) {
                        // Создаем или обновляем первую аннотацию
                        if (!connector.annotations || connector.annotations.length === 0) {
                            connector.annotations = [{}];
                        }
						
                        connector.annotations[0].content = annotationContent;
                        connector.annotations[0].style = { fill: "#fff" }; // для белого фона текста
                    }

                    // 4. Окончательная проверка направления (Out -> In)
                    if (!shouldRemove) {
                        const targetPortObj = targetNode?.ports?.find((p) => p.id === connector.targetPortID);

                        const isSourceOut = firstPortObj?.constraints & PortConstraints.OutConnect;
                        const isTargetIn = targetPortObj?.constraints & PortConstraints.InConnect;

                        if (!(isSourceOut && isTargetIn)) {
                            shouldRemove = true;
                            console.log("Порты несовместимы. Требуется строго Out → In.");
                        }
                    }
                }

                // --- ОТСРОЧЕННОЕ ДЕЙСТВИЕ И СБРОС (для предотвращения ошибок) ---

                setTimeout(() => {
                    if (shouldRemove) {
                        diagram.remove(connector);
                    }
					else {
                        let transitionKey = sourcePortId.split("_").pop();
                        let transitionActivityId = Number(connector.targetID.replace(nodeIdPrefix, ""));
                        let schemeDataItemId = Number(connector.sourceID.replace(nodeIdPrefix, ""));
                        
                        let sourceItem = this.schemeData.find((x) => x.Id == schemeDataItemId);
                        let targetItem = this.schemeData.find((x) => x.Id == transitionActivityId);

                        // Регистрируем переход
                        sourceItem.Transitions ??= [];
                        sourceItem.Transitions.push({ Key: transitionKey, ActivityId: targetItem.Id });

                        // Если привязка была автоматической, коннектор нужно обновить
                        diagram.dataBind();
                        console.log("Коннектор успешно создан (Out → In).");
                    }

                    // Обязательный сброс инструмента и drawingObject
                    diagram.tool = DiagramTools.SingleSelect | DiagramTools.ZoomPan;
                    diagram.drawingObject = null;

                    // Финальное обновление диаграммы
                    diagram.dataBind();
                }, 10);
            }

            console.log("schemeData", this.schemeData);

            // Проверяем удаление ноды или коннекта
            if (args.type === "Removal") {
                if (args.element.propName == "nodes") {
                    let schemeDataItemId = Number(args.element.properties.id.replace(nodeIdPrefix, ""));
                    this.schemeData = this.schemeData.filter((t) => t.Id != schemeDataItemId);
                }

                if (args.element.propName == "connectors") {
                    let transitionKey = args.element.properties.sourcePortID.split("_").pop();
                    let schemeDataItemId = Number(args.element.properties.sourceID.replace(nodeIdPrefix, ""));
                    let schemeDataItem = this.schemeData.find((x) => x.Id == schemeDataItemId);

                    if (schemeDataItem) {
                        schemeDataItem.Transitions = schemeDataItem.Transitions.filter((t) => t.Key != transitionKey);
                    }
                }
            }
        },
        onSelectionChange() {
            const diagram = this.getDiagram();
			// true, если есть выделенные узлы
            this.hasSelection = diagram.selectedItems.nodes.length == 1 || diagram.selectedItems.connectors.length > 0;
            let hasSelectionOnlyNodes = diagram.selectedItems.nodes.length == 1;

            if (hasSelectionOnlyNodes) {
                const selectedNode = diagram.selectedItems?.properties?.nodes[0];
                this.selectionNodeId = selectedNode?.id;
                this.selectionNodeData = selectedNode?.addInfo.nodeTechInfo;
            }
			else 
            {
                this.selectionNodeId = null;
                this.selectionNodeData = null;
            }
			
            setTimeout(() => {
                //видимость панели опций блоков
                this.drawerPropSettings = hasSelectionOnlyNodes;
            }, 200);

            this.propertyItemsMenuActiveGroup = 0;
            /*console.log('this.selectionNodeData', diagram.selectedItems?.properties?.nodes[0]?.nodeTechInfo);*/
        },
        onDragStart(item, evt) {
            this.draggedItem = item;

            // для совместимости с браузерами: указываем эффект и минимальные данные,
            // чтобы браузер позволил начать drag (особенно важно для Firefox)
            try {
                evt.dataTransfer.effectAllowed = "copy";
                // небольшая запись — нужна некоторым браузерам, иначе drag не разрешают
                evt.dataTransfer.setData("text/plain", "");
            }
			catch (e) {
                // ignore — это только для совместимости
            }
        },
        onDragEnd() {
            this.draggedItem = null;
        },
        getDropCoordinates(evt) {
            const diagram = this.getDiagram();
            const rect = this.$refs.diagram.$el.getBoundingClientRect();

            // получаем зум и смещения из scrollSettings
            const zoom = diagram.scrollSettings.currentZoom || 1;
            const scrollX = diagram.scrollSettings.horizontalOffset || 0;
            const scrollY = diagram.scrollSettings.verticalOffset || 0;

            // вычисляем положение курсора относительно контейнера диаграммы
            const rawX = evt.clientX - rect.left;
            const rawY = evt.clientY - rect.top;

            // компенсируем зум и скролл (всё в координаты диаграммы)
            const offsetX = (rawX + scrollX) / zoom;
            const offsetY = (rawY + scrollY) / zoom;

            return { offsetX, offsetY };
        },
        onDiagramDrop(evt) {
            evt.preventDefault();

            if (!this.draggedItem) return;

            const diagram = this.getDiagram();

            if (!diagram) {
                this.draggedItem = null;
                return;
            }

            //id и title ноды
            const schemeDataId = findSmallest(this.schemeData.map((x) => Number(x.Id)));
            const nodeId = `${nodeIdPrefix}${schemeDataId}`;
            let content = "";

            if (this.draggedItem.shape?.shape === "Activity") {
                content = this.draggedItem.displayName || this.draggedItem.name || "Node";
            }

            const { offsetX, offsetY } = this.getDropCoordinates(evt);

            // shape
            let shape = this.draggedItem.shape;
            // annotations
            const numericId = this.getNumericId(nodeId); // Получаем числовой ID
            let annotations = [
                { content },
                // аннотация для ID ноды
                {
                    content: `${numericId}`,
                    offset: { x: 1, y: 0 },
                    margin: { top: -1, left: 6 },
                    style: { 
                        color: '#666', 
                        fill: 'transparent',
                        fontSize: 12,
                        bold: true
                    }
                }
            ];

            //fill & stroke
            let fill = "#ffffff";
            let strokeColor = "#333";
            let strokeWidth = "4";

            if (this.draggedItem.shape?.event?.event === "Start") {
                strokeColor = "#76b332";
            }

            if (this.draggedItem.shape?.event?.event === "Intermediate") {
                strokeColor = "#a6a61d";
            }

            if (this.draggedItem.shape?.shape === "Gateway") {
                fill = "#ffffcc";
                strokeColor = "#a6a61d";
            }

            if (this.draggedItem.shape?.event?.event === "End") {
                fill = "#9e0c0c";
                strokeColor = "#9e0c0c";
            }

            if (this.draggedItem.shape?.shape === "Activity") {
                fill = "#ecefff";
                strokeColor = "#03689a";
            }

            //размеры блоков
            let widthN = 140;
            let heightN = 70;

            if (this.draggedItem.shape?.type === "Bpmn" && (this.draggedItem.shape?.shape === "Event" || this.draggedItem.shape?.shape === "Gateway")) {
                widthN = 50;
                heightN = 50;
            }

            // properties
            let properties = _.cloneDeep(this.draggedItem?.properties);

            // Пишем данные для описания схемы
            let schemeDataItem = {
                Id: schemeDataId,
                __type: this.draggedItem?.type,
                ParentId: -1,
                ThreadId: -1,
                Transitions: [],
            };

            this.draggedItem?.properties.forEach((el) => {
                el?.items.forEach((prop) => {
                    schemeDataItem[prop.name] = prop.webEditorAttribute.Default;
                });
            });

            this.schemeData.push(schemeDataItem);

            let ports = [];
            ports = this.buildPortObj(this.draggedItem, nodeId, schemeDataItem);

            // добавляем ноду на диаграмму
            diagram.add({
                id: nodeId,
                width: widthN,
                height: heightN,
                offsetX,
                offsetY,
                shape,
                annotations: annotations,
                style: {
                    fill: fill,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                },
                ports,
                addInfo: {
                    nodeTechInfo: properties,
                },
                constraints:
                    NodeConstraints.Default &
                    ~NodeConstraints.Rotate &
                    ~NodeConstraints.Resize,
            });

            // вернём режим редактирования и очистим state
            diagram.tool = this.tool;
            diagram.dataBind();
            this.draggedItem = null;
            evt.preventDefault();
        },
        onPortClick(args) {
            const diagram = this.getDiagram();
            const element = args.element;

            // 1. Проверяем, что кликнули именно по порту
            if (element && element.constructor.name === "PointPort") {
                const port = element;
                const parentNode = port.parentObj;
                // Получаем объект порта для проверки ограничений
                const portObj = parentNode.ports?.find((p) => p.id === port.id);
                // Проверяем, является ли порт исходящим (OutConnect)
                const isOutPort = portObj?.constraints & PortConstraints.OutConnect;

                if (isOutPort) {
                    // Активируем режим рисования, который завершится после одного коннектора
                    diagram.tool = DiagramTools.SingleSelect | DiagramTools.ZoomPan | DiagramTools.DrawOnce;

                    // Настраиваем объект, который будет рисоваться (Orthogonal Connector)
                    diagram.drawingObject = {
                        id: "temp_connector_" + Date.now(),
                        type: "Orthogonal",
                        sourceID: parentNode.id, // Привязка к исходной ноде
                        sourcePortID: port.id, // Привязка к исходному порту
                        // Ваши стили коннектора
                        style: {
                            strokeColor: "#333",
                            strokeWidth: 2,
                        },
                        targetDecorator: {
                            shape: "Arrow",
                            width: 8,
                            height: 8,
                            style: { fill: "#333", strokeColor: "#333" },
                        },
                        annotations: [
                            {
                                style: {
                                    color: "black",
                                    fill: "#fff",
                                    strokeColor: "#fff",
                                },
                            },
                        ],
                    };

                    diagram.dataBind();
                    console.log("Режим рисования коннектора активирован от порта:", port.id);
                }
				else if (portObj?.constraints & PortConstraints.InConnect) {
                    console.log("Нельзя начинать рисование с входящего порта (InConnect).");
                    // Если режим рисования был активен, мы его сбросим,
                    // чтобы избежать ошибок при попытке "дорисовать"
                    diagram.tool = DiagramTools.SingleSelect | DiagramTools.ZoomPan;
                    diagram.drawingObject = null;
                    diagram.dataBind();
                }
            } 
            else if(element.constructor.name === "Diagram")
            {
                // 2. Клик по полю диаграммы где нет ничего
                this.selectionNodeId = null;
                this.selectionNodeData = null;
                this.drawerPropSettings = false;
                this.hasSelection = false;
                this.getDiagram().clearSelection();
            }
        },
        generateId() {
            // Генератор случайного UUID
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
				const r = (Math.random() * 16) | 0;
				const v = c === "x" ? r : (r & 0x3) | 0x8;
				return v.toString(16);
			});
        },
        getNumericId(nodeId) {
            if (!nodeId) return '';
            // Используем константу nodeIdPrefix = "Node_", которая определена выше.
            const prefix = nodeIdPrefix; 
            if (nodeId.startsWith(prefix)) {
                return nodeId.replace(prefix, '');
            }
            // Безопасное извлечение, если префикс не сработал
            const match = nodeId.match(/\d+$/);
            return match ? match[0] : '';
        },
        transformActivities(jsonData) {
            // Группируем по категории
            const grouped = _.groupBy(jsonData, (item) => _.get(item, "ActivityAttribute.Category", "Без категории"));
            // Формируем итоговую структуру
            const result = _.map(grouped, (activities, categoryName) => ({
                id: this.generateId(),
                name: categoryName,
                items: _.chain(activities)
						.map((activity) => ({
							id: this.generateId(),
							type: _.get(activity, "Type", []),
							displayName: _.get(activity, "ActivityAttribute.Name", "Без названия"),
							icon: this.getIconItemMenu(_.get(activity, "BpmnElement", null)),
							shape: this.buildShapeObj(_.get(activity, "BpmnElement", null)),
							possibleResultAttributes: _.get(activity, "PossibleResultAttributes", []),
							triggerAttributes: _.get(activity, "TriggerAttributes", []),
							properties: this.transformProperties(_.get(activity, "Properties", [])),
						}))
						.sortBy("displayName") // сортировка активностей внутри категории
						.value(),
            }));
            // Сортировка категорий по алфавиту
            return _.sortBy(result, "name");
        },
        transformProperties(originalProp) {
            const grouped = _.groupBy(originalProp, (item) => _.get(item, "CategoryAttribute.Category", "Без категории"));
            const result = _.map(grouped, (properties, categoryName) => ({
                id: this.generateId(),
                name: categoryName,
                items: _.chain(properties)
						.map((property) => ({
							id: this.generateId(),
							name: _.get(property, "Name", null),
							type: _.get(property, "Type", null),
							displayName: _.get(property, "DisplayNameAttribute.DisplayName", "Без названия"),
							description: _.get(property, "DescriptionAttribute.Description", ""),
							enumValues: _.get(property, "EnumValues", []),
							webEditorAttribute: _.get(property, "WebEditorAttribute", {}),
						}))
						.value(),
            }));
            // Сортировка категорий по алфавиту
            return _.sortBy(result, "name");
        },
        buildShapeObj(BpmnElement) {
            let TypeId = BpmnElement.TypeId;
            let Shape = BpmnElement.Shape;
            let Type = BpmnElement.Type;
            let Trigger = "";
            let Activity = "";
            let Loop = "";

            switch (TypeId) {
                case "BpmnEventAttribute":
                    Trigger = BpmnElement.Trigger;
                    return {
                        type: "Bpmn",
                        shape: Shape,
                        event: {
                            event: Type,
                            trigger: Trigger,
                        },
                    };
                case "BpmnGatewayAttribute":
                    return {
                        type: "Bpmn",
                        shape: Shape,
                        gateway: {
                            type: Type,
                        },
                    };
                case "BpmnActivityAttribute":
                    Activity = BpmnElement.Activity;
                    //let Loop = BpmnElement.Loop;
                    return {
                        type: "Bpmn",
                        shape: Shape,
                        activity: {
                            activity: Activity,
                            task: {
                                type: Type,
                                loop: Loop,
                            },
                        },
                    };
                default:
                    return "Неизвестный режим";
            }
        },
        buildPortObj(draggedItem, nodeId, dataItem) {
            let ports = [];
            let portColor = "#666666";
            let portHeight = 10;
            let portWidth = 10;

            // Вход всегда один и он есть, кроме стартового
            if (draggedItem.shape?.event?.event !== "Start") {
                ports.push({
                    id: `port_in_${nodeId}`,
                    offset: { x: 0.5, y: 0 },
                    visibility: PortVisibility.Visible,
                    shape: "Circle",
                    width: portWidth,
                    height: portHeight,
                    style: { strokeColor: portColor, strokeWidth: 1.5 },
                    constraints: PortConstraints.InConnect | PortConstraints.ToolTip,
                    tooltip: { content: "Вход", position: "TopCenter" },
                });
            }
            // Порты выхода
            // Снизу
            draggedItem?.possibleResultAttributes.map((item, index) => {
                const total = draggedItem?.possibleResultAttributes.length;
                const step = 1 / (total + 1);
                let portOffset = { x: step * (index + 1), y: 1 };

                if (draggedItem.shape?.gateway?.type === "Exclusive") {
                    if (item.Value == "True") {
                        portOffset = { x: 1, y: 0.5 };
                    }
                    if (item.Value == "False") {
                        portOffset = { x: 0, y: 0.5 };
                    }
                }

                if (draggedItem.shape?.gateway?.type === "Parallel" &&
                    draggedItem?.possibleResultAttributes.length > 1) 
                {
                    if(index == 0)
                    {
                        portOffset = { x: 0, y: 0.5 };
                    }
                    else if(index == 2)
                    {
                        portOffset = { x: 1, y: 0.5 };
                    }
                }

                ports.push({
                    id: `port_out_${nodeId}_${item.Value}`,
                    offset: portOffset,
                    visibility: PortVisibility.Visible,
                    shape: "Circle",
                    width: portWidth,
                    height: portHeight,
                    style: { strokeColor: portColor, strokeWidth: 1.5 },
                    constraints: PortConstraints.OutConnect | PortConstraints.ToolTip,
                    tooltip: { content: item.Name, position: "TopCenter" },
                });
            });

            // Справа
            draggedItem?.triggerAttributes.map((item, index) => {
                const total = draggedItem?.triggerAttributes.length;
                const step = 1 / (total + 1);
                let portOffset = { x: 1, y: step * (index + 1) };
                let portVisibility = PortVisibility.Hidden;

                if (dataItem[item.Source] == item.DesiredValue) {
                    portVisibility = PortVisibility.Visible;
                }

                if (draggedItem.shape?.shape === "Activity") {
                    if (item.Value == "Timer") {
                        portColor = "#a6a61d";
                    }
                    if (item.Value == "Error") {
                        portColor = "#E57373";
                    }
                }

                ports.push({
                    id: `port_out_right_${nodeId}_${item.Value}`,
                    offset: portOffset,
                    visibility: portVisibility,
                    shape: "Circle",
                    width: portWidth,
                    height: portHeight,
                    style: { strokeColor: portColor, strokeWidth: 2.5 },
                    constraints: PortConstraints.OutConnect | PortConstraints.ToolTip,
                    tooltip: { content: item.Name, position: "TopCenter" },
                });
            });

            //console.log(draggedItem, ports);
            return ports;
        },
        getIconItemMenu(BpmnElement) {
            let TypeId = BpmnElement.TypeId;

            switch (TypeId) {
                case "BpmnEventAttribute":
                    return "mdi mdi-circle-outline";
                case "BpmnGatewayAttribute":
                    return "mdi mdi-rhombus-outline";
                case "BpmnActivityAttribute":
                    return "mdi mdi-square-rounded-outline";
                default:
                    return "";
            }
        },
        hidePortsByPartialId(partialId, value) {
            // Проверка наличия данных и получение экземпляра диаграммы
            if (!this.selectionNodeId) {
                console.warn("Нет выбранного узла (не имеет ID).");
                return;
            }

            const diagram = this.getDiagram();
            const nodeId = this.selectionNodeId;
            // Получение объекта узла
            const node = diagram.getObject(nodeId);

            if (!node || !node.ports) {
                console.error(`Узел с ID ${nodeId} не найден или не содержит портов.`);
                return;
            }

            // Фильтрация и изменение видимости портов
            // Ищем порты, чей ID содержит указанную часть (например, 'Timer' или 'Error')
            const regex = new RegExp(`^port_out_right_${nodeIdPrefix}[^_]+_${partialId}$`);
            const portsToUpdate = node.ports.filter((p) => regex.test(p.id));

            if (portsToUpdate.length > 0) {
                portsToUpdate.forEach((port) => {
                    const portId = port.id;

                    // Удаление коннекторов только при СКРЫТИИ (value == false)
                    if (!value) {
                        const connectedConnectors = diagram.connectors.filter((c) => c.sourceID === nodeId && c.sourcePortID === portId);
                        connectedConnectors.forEach((connector) => diagram.remove(connector));
                    }

					port.visibility = value ? PortVisibility.Visible : PortVisibility.Hidden;
                });

                // 4. Обновление узла на диаграмме
                diagram.dataBind();
                console.log(`На узле ${nodeId} скрыто портов, содержащих ID: ${partialId}`);
            }
			else {
                console.warn(`Порты, содержащие ID "${partialId}", не найдены на узле ${nodeId}.`);
            }
        },
        onPropChange(value, propName, propType) {
            let schemeDataItemId = Number(this.selectionNodeId.replace(nodeIdPrefix, ""));
            let schemeDataItem = this.schemeData.find((x) => x.Id == schemeDataItemId);
            // Обновление временного хранилища данных
            this.$set(schemeDataItem, propName, value);

            if (propName === "UseTimer" || propName === "UseErrorProcessor") {
                let typeRightPort = propName === "UseTimer" ? "Timer" : "Error";
                this.hidePortsByPartialId(typeRightPort, value);
            }

            console.log(`Свойство ${propName} (${propType}) обновлено до:`, value);
            console.log("schemeDataItem", schemeDataItem);
        },
        async onWorkplaceSelect(params, propName) {
            if (params == null || this.isViewMode) return;

            let selectMemberParams = { ...params, selected: [], entid: this.enterprise };

            try
			{
                let workplace = await this.$store.dispatch("dialogs/selectMembersNew/open", selectMemberParams);
                let schemeDataItemId = Number(this.selectionNodeId.replace(nodeIdPrefix, ""));
                let schemeDataItem = this.schemeData.find((x) => x.Id == schemeDataItemId);
                this.$set(schemeDataItem, propName, [workplace]);
            }
			catch (ex) {
                console.log(ex);
            }
        },
        async onRemoveWorkplace(){
            let schemeDataItemId = Number(this.selectionNodeId.replace(nodeIdPrefix, ""));
            let schemeDataItem = this.schemeData.find((x) => x.Id == schemeDataItemId);
            this.$set(schemeDataItem, 'SignerWorkPlaces', []);    
        },
		isPropertyVisible(child) {
			const dependencyName = child.webEditorAttribute.DependsBy;
			// Если DependsBy null
			if (dependencyName == null) {
				return true;
			}
			const dependencyValue = this.currentPropValues[dependencyName];
			return dependencyValue === true;
		},
        save() {
            this.onValidateScheme();
            let diagram = this.getDiagram();
            return { Diagramm: diagram.saveDiagram(), Scheme: JSON.stringify(this.schemeData) };
        },
        load(diagramJson, schemeJson) {
            this.schemeData = JSON.parse(schemeJson);
            const diagram = this.getDiagram();
            diagram.loadDiagram(diagramJson);
            // ПРИНУДИТЕЛЬНАЯ БЛОКИРОВКА СУЩЕСТВУЮЩИХ СВЯЗЕЙ
            diagram.connectors.forEach(c => {
                if (c.sourceID && c.targetID) {
                    c.constraints = STATIC_CONNECTOR_CONSTRAINTS;
                }
            });
            diagram.dataBind();
        },
        syncPulse() {
            const els = document.querySelectorAll('.drawerPropSettings .v-input.error--text fieldset');
            if (!els.length) return;
            // временно отключаем анимацию
            els.forEach(el => el.style.animation = 'none');
            // форсируем reflow, чтобы браузер принял изменения
            void document.body.offsetWidth;
            // включаем обратно (пусть берётся из CSS)
            els.forEach(el => el.style.animation = '');
        },
        errorStyleNodeById(nodeId, newStrokeColor) {
            if (!nodeId) {
                console.warn("styleNodeById: ID ноды не предоставлен.");
                return;
            }
            const diagram = this.getDiagram();
            const node = diagram.getObject(nodeId);
            if (!node || node.propName !== 'nodes') {
                console.warn(`styleNodeById: Узел с ID ${nodeId} не найден или не является нодой.`);
                return;
            }
            let changed = false;
            // Изменение цвета границы
            if (newStrokeColor !== undefined && node.style.strokeColor !== newStrokeColor) {
                node.style.strokeColor = newStrokeColor;
                changed = true;
            }
            if (changed) {
                diagram.dataBind();
                console.log(`Узел ${nodeId} обновлен: Stroke=${newStrokeColor || node.style.strokeColor}`);
            } else {
                console.log(`Узел ${nodeId}: Стили не предоставлены или не изменились.`);
            }
        },
        getStrokeColor(nodeId) {
            if (!nodeId) {
                console.warn("getStrokeColor: ID ноды не предоставлен.");
                this.defaultValidNodeStrokeColor = null;
                return null;
            }
            const diagram = this.getDiagram();
            const node = diagram.getObject(nodeId);
            if (!node || node.propName !== 'nodes') {
                console.warn(`getStrokeColor: Узел с ID ${nodeId} не найден или не является нодой.`);
                this.defaultValidNodeStrokeColor = null;
                return null;
            }
            const color = node.style ? node.style.strokeColor : null;
            this.defaultValidNodeStrokeColor = color; 
            console.log(`Получен цвет границы для ${nodeId}: ${color}`);

            return color;
        },
        onValidateScheme(){
            let check = this.validator(this.schemeData);
            if(check.success){
                //валидна
                this.resetNodeError();
                this.$notify.success(check.message);
            }else if(check.id == null){
                //ошибка глобальная
                this.resetNodeError();
                this.$notify.alert(this.$t(check.message));
            }else{
                //есть id и должны подсветить
                this.setNodeError(check.id, check.message);  
                this.$notify.alert(check.message + " - " + check.id);
            }
        },
        setNodeError(id, message){
            this.resetNodeError();
            let nodeId = nodeIdPrefix + id;
            this.lastErrorNodeId = nodeId;
            this.defaultValidNodeStrokeColor = this.getStrokeColor(nodeId);
            this.errorStyleNodeById(nodeId, this.validateErrorColor);
            this.lastErrorMessage = message;
        },
        resetNodeError(){
            if(this.lastErrorNodeId){
                this.errorStyleNodeById(this.lastErrorNodeId, this.defaultValidNodeStrokeColor);
                this.defaultValidNodeStrokeColor = null;
                this.lastErrorNodeId = null;
                this.lastErrorMessage = null;
            }
        }
    },
    created() {
        this.processItemsMenuTree = this.transformActivities(this.activities);
    },
    updated() {
        this.$refs?.formPropertiesRef?.validate();
        this.$nextTick(() => {
            this.syncPulse();
        }); 
    },
    watch: {
        isViewMode() {
            // следим за состоянием просмотр/редактирование и делаем refresh диаграммы, дабы обновить ее размеры
            setTimeout(() => {
                this.getDiagram().refresh();
            }, 350);
        }
    }
};
</script>